import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ErrorProvider } from "./context/ErrorContext";
import { ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import theme from './theme.js';
import JobList from "./pages/JobListPage";
import Navbar from "./components/Navbar";
import AuthGuard from "./components/AuthGuard";
import PublicRoute from "./components/PublicRoute";
import TokenHandler from "./components/TokenHandler";
import AuthPage from "./pages/AuthPage";
import AuthLand from "./pages/AuthLandPage";
import ManageSelf from "./pages/ManageSelfPage";
import JobDetails from "./pages/JobDetailsPage";
import JobApply from "./pages/JobApplyPage";
import ApplicationSelfList from "./pages/ApplicationsSelfPage";
import ProfilePage from "./pages/UserProfilePage.js";
import DashboardPage from "./pages/DashboardPage.js";
import MyApplicationPage from "./pages/MyApplicationPage.js";
import Home from "./components/Home.js";

const App = () => (
    <ThemeProvider theme={theme}>
      <ErrorProvider>
        <AuthProvider>
          <Router>
            <TokenHandler>
              <Navbar />
              <Box
                sx={{
                  marginLeft: { xs: 0, md: '80px' },
                  marginTop: { xs: '64px', md: 0 },
                  minHeight: '100vh',
                  backgroundColor: '#f9fafc',
                }}
              >
                <Routes>
              {/* Public Auth Routes - No AuthGuard */}
              <Route path="/auth/sign-in/*" element={<AuthPage mode="sign-in" />} />
              <Route path="/auth/sign-up/*" element={<AuthPage mode="sign-up" />} />
              
              {/* Legacy redirects for old sign-in/sign-up URLs */}
              <Route path="/sign-in/*" element={<Navigate to="/auth/sign-in" replace />} />
              <Route path="/sign-up/*" element={<Navigate to="/auth/sign-up" replace />} />
              
              {/* Root Route - Landing Page */}
              <Route path="/" element={<Home />} />
              
              {/* Public Routes - Accessible to everyone (logged in or not) */}
              <Route path="/opportunities/" element={<PublicRoute><JobList /></PublicRoute>} />
              <Route path="/opportunities/:id/details" element={<PublicRoute><JobDetails /></PublicRoute>} />
              
              {/* Legacy redirects */}
              <Route path="/job" element={<Navigate to="/opportunities" replace />} />
              <Route path="/jobs" element={<Navigate to="/opportunities" replace />} />
              <Route path="/jobs/:id/details" element={<Navigate to="/opportunities/:id/details" replace />} />

              {/* Protected Routes - Require Authentication */}
              <Route path="/opportunities/:id/apply" element={<AuthGuard><JobApply /></AuthGuard>} />
              <Route path="/jobs/:id/apply" element={<Navigate to="/opportunities/:id/apply" replace />} />
              <Route path="/application" element={<AuthGuard><ApplicationSelfList /></AuthGuard>} />
              <Route path="/land" element={<AuthGuard><AuthLand /></AuthGuard>} />
              <Route path="/manage-self" element={<AuthGuard><ManageSelf /></AuthGuard>} />
              <Route path="/profile" element={<AuthGuard><ProfilePage /></AuthGuard>}/>
              <Route path="/profile/:id" element={<AuthGuard><ProfilePage /></AuthGuard>}/>
              <Route path="/dashboard" element={<AuthGuard><DashboardPage /></AuthGuard>} />
              <Route path="/my-application/:id" element={<AuthGuard><MyApplicationPage /></AuthGuard>} />
            </Routes>
              </Box>
            </TokenHandler>
          </Router>
        </AuthProvider>
      </ErrorProvider>
    </ThemeProvider>
);

export default App;
